import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ensurePermissions } from '@/hooks/usePermissions';

const myComponentsSearch = z.object({
  page: z.number().optional(),
  limit: z.number().optional(),
  sort: z.string().optional(),
  filters: z.record(z.string(), z.array(z.string())).optional(),
});

export const Route = createFileRoute('/(client)/my-components/(pages)')({
  validateSearch: myComponentsSearch,
  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.styles.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    if (
      location.pathname === '/my-components' ||
      location.pathname === '/my-components/'
    ) {
      throw redirect({ to: '/my-components/components/active' });
    }
  },
});
